export const getDefaultRoute = ({ isDonor, isReadOnly, isMerchOnly, isMyPagesOnly, isAgency, profileCandidate }) => {
  if (isDonor) return 'team-pages/pages';
  if (isReadOnly) return `${profileCandidate.organization_revv_uid}/people/donors`;
  if (isMerchOnly) return `${profileCandidate.organization_revv_uid}/merchandise/products`;
  if (isMyPagesOnly) return `${profileCandidate.organization_revv_uid}/pages/my-pages`;
  if (isAgency) return `${profileCandidate.organization_revv_uid}/vendors/dashboard`;
  return `${profileCandidate.organization_revv_uid}/dashboard`;
};
